<template>
  <div class="index container">
     <a class = "add-button">Add a new place <router-link :to="{name:'AddPlace'}" class = "btn-floating btn-large pink" ><i class="material-icons edit">add</i></router-link></a>
    <div class= "places row">
      
     
        <div v-for="place in places" :key="place.id" class="place card col l3 m4 s12">
          <div class="class-image">
            <img class = "image" :src="place.imageUrl" alt="">
            <span class="card-title chip">{{(place.name).slice(0,30)}}</span>
            <span v-if="place.owner" class="right delete"><i @click="deletePlace(place.id)" class="material-icons edit red-text">delete</i></span>
            
          </div>
          <div  class="card-content">
            <p>{{(place.type).slice(0,40)}}</p>
            <p>By {{(place.author.name).slice(0,40)}}</p>
            <router-link :to="({name:'Place', params:{place_id:place.slug}})">
              view {{(place.name).slice(0,40)}}
            </router-link>
                      
          </div>
          <span  v-if="place.owner" class = "btn-floating btn-large halfway-fab pink">
            <router-link :to="({name:'EditPlace', params:{place_slug:place.slug}})">
              <i class="material-icons edit">edit</i>
            </router-link>
            
          </span>
          
        </div>
       </div>  
    </div>
  
</template>

<script>
import db from "@/firebase/init"
import firebase from "firebase"
export default {
  name: 'Index',
  data () {
    return {
     places:[ ],
      owner:null
    }
  },
  methods:{
    deletePlace(id){
      console.log(id)
      
       var storage = firebase.storage();
    
        let ref = db.collection("places").where("slug","==", id)
         ref.get()
          .then((snapshot) => {
            snapshot.forEach((doc)=> {
              var removeRef = firebase.storage().ref("places/" + doc.data().imageName + ".jpg")
              console.log(removeRef)
              removeRef.delete()
              db.collection("places").doc(id).delete()
                  .then(() => {
                    this.places = this.places.filter(place => {
                      return place.id != id
                      })
                  })
              
          })
          })
     
      
    }
  },
  created(){
     let user = firebase.auth().currentUser
    db.collection("places").get()
    .then(snapshot => {
      snapshot.forEach(doc => {
        let place = doc.data()
        console.log(place)
        place.id = doc.id
        if(user){
           place.owner = (place.author.id === user.uid)
        }else{
           place.owner = false
        }
        
        this.places.push(place)
       
      })
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
/* .index .places{
  display:grid;
  grid-template-columns:repeat(3, 1fr);
  grid-gap:30px;
  margin-top:60px;
} */
body{
  background-color: #e9ebee;
}
 .index .card{
  
  margin-top:60px;
  
} 
 
.index .places .card-content{
  
  
  padding-left:0; 
  font-size:small
}
.index .image{
  width:100%;
max-width:100%;
height:150px;
object-fit: cover;
}
/* .index .places .place{
  

  margin:1%;
} */
.index .add-button{
  margin:0;
  padding:0;
}
.index .places{
  margin:0;
  padding:0;
}
.index .delete{
  cursor:pointer;
}
.index .card .card-title{
  font-size:small;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue